/**
 * Grail27 — WhatsApp float on PDP mobile:
 * - Hidden at load while in-page ATC / wallet row is still in view (same fixed position).
 * - Visible at bottom-right after user scrolls past buy buttons.
 * - Bumps up when sticky ATC bar appears (original behavior).
 */
(function () {
  var MOBILE_MAX = 768;
  var WA_CLEARANCE = 90;

  function init() {
    var waBtn = document.querySelector('.floating-whatsapp');
    if (!waBtn) return;

    var flags = window.GrailWhatsApp || {};
    if (!flags.syncStickyBump) return;

    var raf = 0;

    function scrolledPastBuyArea() {
      var buy = document.querySelector('.grail-product-buy-custom');
      if (!buy) return true;
      var rect = buy.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) return true;
      return rect.bottom < window.innerHeight - WA_CLEARANCE;
    }

    function stickyBarVisible() {
      var sticky = document.getElementById('grail-sticky-bar');
      if (!sticky) return false;
      return (
        sticky.classList.contains('grail-sticky-visible') &&
        !sticky.classList.contains('grail-hidden-by-footer')
      );
    }

    function syncWhatsApp() {
      if (window.innerWidth > MOBILE_MAX) {
        waBtn.classList.remove('wa-hidden-by-pay');
        waBtn.classList.remove('bump-up');
        return;
      }

      if (stickyBarVisible()) {
        waBtn.classList.remove('wa-hidden-by-pay');
        waBtn.classList.add('bump-up');
        return;
      }

      waBtn.classList.remove('bump-up');

      if (scrolledPastBuyArea()) {
        waBtn.classList.remove('wa-hidden-by-pay');
      } else {
        waBtn.classList.add('wa-hidden-by-pay');
      }
    }

    function scheduleSync() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        syncWhatsApp();
      });
    }

    var stickyBar = document.getElementById('grail-sticky-bar');
    if (stickyBar) {
      var mo = new MutationObserver(scheduleSync);
      mo.observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
    }

    window.addEventListener('resize', scheduleSync);
    window.addEventListener('orientationchange', scheduleSync);
    window.addEventListener('scroll', scheduleSync, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleSync);
      window.visualViewport.addEventListener('scroll', scheduleSync);
    }

    scheduleSync();
    window.setTimeout(scheduleSync, 400);
    window.setTimeout(scheduleSync, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
